function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11657",
  "data-name": "Path 11657",
  d: "M1.125,37.6H44.157V4.5H1.125ZM4.435,7.81H40.847V34.291H4.435Z",
  transform: "translate(5.495 2.12)",
  fill: "#ac1ede"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11658",
  "data-name": "Path 11658",
  d: "M10.06,41.571V13.435H48.127v-3.31H6.75V41.571Z",
  transform: "translate(-6.75 -10.125)",
  fill: "#ac1ede"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11659",
  "data-name": "Path 11659",
  d: "M18.136,10.253c-4.106,0-7.449,3.635-7.449,8.1s3.341,8.1,7.449,8.1,7.449-3.635,7.449-8.1S22.243,10.253,18.136,10.253Zm0,12.895C15.854,23.148,14,21,14,18.356s1.857-4.792,4.138-4.792,4.138,2.149,4.138,4.792-1.857,4.792-4.138,4.792Z",
  transform: "translate(10.001 4.802)",
  fill: "#ac1ede"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11660",
  "data-name": "Path 11660",
  d: "M8.935,27.769H5.625V9.563h3.31Z",
  transform: "translate(34.097 4.504)",
  fill: "#ac1ede"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11661",
  "data-name": "Path 11661",
  d: "M26.935,27.769h-3.31V9.563h3.31Z",
  transform: "translate(-10.384 4.504)",
  fill: "#ac1ede"
});

var SvgMoney = function SvgMoney(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "money",
    width: 49.652,
    height: 39.722,
    viewBox: "0 0 49.652 39.722",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money.eb49c97e.svg";
export { ForwardRef as ReactComponent };